import { View } from "./View";

interface IOnboardingHeaderProps {
  handleComplete: () => void;
  handleCancel: () => void;
}

export const OnboardingHeader = (props: IOnboardingHeaderProps) => {
  return <View {...props} />;
};
